import React from 'react';
import { cx } from '../cx';

// D-09 §15.23 — Pagination (.pager > button[.active]) · controlled (1-based)
export interface PaginationProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
}

export function Pagination({ page, pageCount, onChange, className = '', ...props }: PaginationProps) {
  const pages = Array.from({ length: Math.max(0, pageCount) }, (_, i) => i + 1);
  return (
    <div className={cx('pager', className)} {...props}>
      <button type="button" disabled={page <= 1} onClick={() => onChange(page - 1)} aria-label="이전">
        ‹
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          className={p === page ? 'active' : ''}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= pageCount}
        onClick={() => onChange(page + 1)}
        aria-label="다음"
      >
        ›
      </button>
    </div>
  );
}
